export const isPastEvent = (eventAt: string | null | undefined, now: number): boolean =>
  !!eventAt && new Date(eventAt).getTime() < now;

type LocationAddress = {
  city?: string | null;
  state?: string | null;
  name?: string | null;
  fullAddress?: string | null;
};

// The short label shown for an address: "City, ST" when both are present, else the address name or
// its full string.
export const formatFulfillmentLocation = (address: LocationAddress): string => {
  if (address.city && address.state) return `${address.city}, ${address.state}`;
  return address.name ?? address.fullAddress ?? '';
};
